module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot1-b37c3f6b685bdddab23bb99a017d800a.png";